module.exports = __webpack_public_path__ + "media/images/favicons/apple-touch-icon-596c5f9329d332f71e8a554b8ae9c6fc.png";